import * as AppUser from '../../constants/AppUser';

const initialState = {
  Loading: false,
  Loaded: false,
};

export default function appUser(state: any = initialState, action: any) {
  switch (action.type) {
    case AppUser.SUCCESS:
      return Object.assign({}, state, {
        Loading: false,
        Loaded: true,
        result: action.result,
      });
    case AppUser.ERROR:
      return Object.assign({}, state, {
        Loading: false,
        Loaded: true,
        result: action.result,
      });
    case AppUser.LOADING:
      return Object.assign({}, state, {
        Loading: true,
        Loaded: false,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/AppUser.tsx